import Head from "next/head";
import BreadcrumbScrollCX from "../../../components/Elements/BreadcrumbScrollCX/BreadcrumbScrollCX";
import cx from "classnames";
import styles from "../../../styles/CXpages.module.css";
import ogCX from "../../../images/ogCX.png";
import { useRef, useState } from "react";
import { useScroll, motion, calcLength } from "framer-motion";
import { useDetectScroll } from "@smakss/react-scroll-direction";
import cxVline from "../../../images/cxVline.svg";
import useIntersection from "../../../components/Services/useIntersection";
import Image from "next/image";
import circle from "../../../images/circle.svg";
import linkShare from "../../../images/linkShare.svg";
import emailShare from "../../../images/emailShare.svg";
import telegramShare from "../../../images/telegramShare.svg";
import whatsappShare from "../../../images/whatsappShare.svg";
import iPhoneFrame from "../../../images/iPhoneFrame.svg";

import { useRouter } from "next/router";
import Snackbar from "@mui/material/Snackbar";
import like from "../../../images/like.svg";
import dislike from "../../../images/dislike.svg";
import sentimentChartDesktop from "../../../images/sentimentChartDesktop.svg";
import sentimentChartMobile from "../../../images/sentimentChartMobile.svg";
import Link from "next/link";
import cx1 from "../../../images/cx1.svg";
import cx2 from "../../../images/cx2.svg";
import cx3 from "../../../images/cx3.svg";
import cx4 from "../../../images/cx3.svg";

import cxArrow from "../../../images/cxArrow.svg";

const Index = () => {
  const router = useRouter();

  const pageDetails = {
    pageTitle: "تحلیل احساس در شبکه‌های اجتماعی",
    pagePath: `https://about.digikala.com${router.asPath}`,
    pageDesc:
      "در این مقاله درباره رصد شبکه‌های اجتماعی و تحلیل سنتیمنت کاربران نسبت به دیجی‌کالا می‌خوانید. علاوه بر توییتر، دیدگاه‌های کاربران و مشتریان در اینستاگرام، لینکدین و تلگرام هم پایش می‌شود.",
  };

  // toast handler after link copy
  const [openToast, setOpenToast] = useState(false);
  const onShareHandler = () => {
    navigator.clipboard.writeText(pageDetails.pagePath);
    openToastHandler();
  };
  const openToastHandler = () => {
    setOpenToast(true);
  };
  const closeToastHandler = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenToast(false);
  };
  // end of toast handler after link copy

  const ref1 = useRef();
  const ref2 = useRef();
  const ref3 = useRef();
  const ref4 = useRef();
  const ref5 = useRef();

  const refBillion = useRef();

  const { scrollYProgress: scroll1 } = useScroll({
    target: ref1,
    offset: ["start end", "end end"],
  });
  const { scrollYProgress: scroll2 } = useScroll({
    target: ref2,
    offset: ["start end", "end end"],
  });
  const { scrollYProgress: scroll3 } = useScroll({
    target: ref3,
    offset: ["start end", "end end"],
  });
  const { scrollYProgress: scroll4 } = useScroll({
    target: ref4,
    offset: ["start end", "end end"],
  });
  const { scrollYProgress: scroll5 } = useScroll({
    target: ref5,
    offset: ["start end", "end end"],
  });

  const { scrollYProgress: scrollAll } = useScroll({
    offset: ["start end", "end end"],
  });
  const spring = {
    type: "spring",
    damping: 10,
    stiffness: 1,
  };

  const [scrollDir] = useDetectScroll({});

  const ref1inViewport = useIntersection(ref1, "0px");
  const ref2inViewport = useIntersection(ref2, "0px");
  const ref3inViewport = useIntersection(ref3, "0px");
  const ref4inViewport = useIntersection(ref4, "0px");
  const ref5inViewport = useIntersection(ref5, "0px");

  return (
    <>
      <Head>
        <title>{pageDetails.pageTitle}</title>
        <meta name="viewport" content="initial-scale=1.0, width=device-width" />
        <meta charSet="utf-8" />
        <meta name="description" content={pageDetails.pageDesc} />
        <link rel="icon" type="image/x-icon" href="/faviconNew.svg"></link>
        <meta
          name="robots"
          content="index, follow, max-snippet:-1, max-video-preview:-1, max-image-preview:large"
        />
        <meta property="og:locale" content="fa_IR" />
        <meta property="og:type" content="website" />
        <meta property="og:title" content={pageDetails.pageTitle} />
        <meta property="og:url" content={pageDetails.pagePath} />
        <meta property="og:site_name" content="درباره گروه دیجی‌کالا" />
        <meta property="og:image" content="/ogCX.png" />
        <meta property="og:image:width" content="665" />
        <meta property="og:image:height" content="370" />
        <meta property="og:image:alt" content={pageDetails.pageTitle} />
        <meta property="og:image:type" content="image/png" />
        <meta
          property="og:site_name"
          content="درباره گروه دیجی‌کالا"
          key="ogsitename"
        />
        <meta
          property="og:title"
          content={pageDetails.pageTitle}
          key="ogtitle"
        />
        <meta
          property="og:description"
          content={pageDetails.pageDesc}
          key="ogdesc"
        />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={pageDetails.pageTitle} />
        <meta name="twitter:site" content="درباره گروه دیجی‌کالا" />
        <meta
          name="twitter:image"
          content="https://about.digikala.com/ogCX.png"
        />
        <meta name="twitter:description" content={pageDetails.pageDesc} />
      </Head>

      <Snackbar
        open={openToast}
        autoHideDuration={2000}
        onClose={closeToastHandler}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
        message={
          <div className="w-100 d-flex align-items-center justify-content-between">
            <span className={cx(styles.toasTextStyles, "d-flex", "w-100")}>
              لینک مطلب کپی شد!
            </span>
          </div>
        }
      />

      <BreadcrumbScrollCX
        title="شاخص‌های اصلی"
        routeOne="/customer-experience/"
        titleOne="درباره تجربه مشتریان"
        routeTwo="/customer-experience/social-media-analysis/"
        titleTow="شاخص‌های اصلی"
      />

      <div className={cx(styles.mainPage)}>
        <div
          className={cx(
            styles.progressBarMain,
            scrollDir !== "down" ? styles.Stick : styles.notStick
          )}
        >
          <motion.div
            className={cx(styles.progressBarInner)}
            style={{ scaleX: scroll1 }}
            transition={spring}
          />
          <motion.div
            className={cx(styles.progressBarInner)}
            style={{ scaleX: scroll2 }}
            transition={spring}
          />
          <motion.div
            className={cx(styles.progressBarInner)}
            style={{ scaleX: scroll3 }}
            transition={spring}
          />
          <motion.div
            className={cx(styles.progressBarInner)}
            style={{ scaleX: scroll4 }}
            transition={spring}
          />
          <motion.div
            className={cx(styles.progressBarInner)}
            style={{ scaleX: scroll5 }}
            transition={spring}
          />

          {/* On Mobile  */}
          <motion.div
            className={cx(styles.progressBarInnerMobile)}
            style={{ scaleX: scrollAll }}
            transition={spring}
          />
        </div>
        <div
          className={cx(
            styles.progressBarMainTitles,
            scrollDir !== "down" ? styles.Stick : styles.notStick
          )}
        >
          <div
            className={cx(
              styles.progressBarInnerTitle,
              ref1inViewport
                ? ref2inViewport
                  ? styles.mobileShrinkable
                  : ""
                : styles.mobileShrinkable
            )}
            onClick={() =>
              ref1?.current?.scrollIntoView({
                behavior: "smooth",
                block: "start",
              })
            }
          ></div>
          {/* <div className={cx(styles.progressBarInnerVline , "d-none d-md-block")}></div> */}
          <div
            className={cx(
              styles.progressBarInnerTitle,
              ref2inViewport
                ? ref3inViewport
                  ? styles.mobileShrinkable
                  : ""
                : styles.mobileShrinkable
            )}
            onClick={() =>
              ref2?.current?.scrollIntoView({
                behavior: "smooth",
                block: "start",
              })
            }
          >
            {/* <h5>مهم‌ترین شاخص‌های سنجش تجربه مشتریان</h5> */}
          </div>
          {/* <div className={cx(styles.progressBarInnerVline ,  "d-none d-md-block")}></div> */}
          <div
            className={cx(
              styles.progressBarInnerTitle,
              ref3inViewport
                ? ref4inViewport
                  ? styles.mobileShrinkable
                  : ""
                : styles.mobileShrinkable
            )}
            onClick={() =>
              ref3?.current?.scrollIntoView({
                behavior: "smooth",
                block: "start",
              })
            }
          >
            {/* <h5>سنجش تجربه مشتریان در جهان</h5> */}
          </div>
          {/* <div className={cx(styles.progressBarInnerVline ,  "d-none d-md-block")}></div> */}
          <div
            className={cx(
              styles.progressBarInnerTitle,
              ref4inViewport
                ? ref5inViewport
                  ? styles.mobileShrinkable
                  : ""
                : styles.mobileShrinkable
            )}
            onClick={() =>
              ref4?.current?.scrollIntoView({
                behavior: "smooth",
                block: "start",
              })
            }
          >
            {/* <h5>سنجش تجربه مشتریان در جهان</h5> */}
          </div>
          {/* <div className={cx(styles.progressBarInnerVline ,  "d-none d-md-block")}></div> */}
          <div
            className={cx(
              styles.progressBarInnerTitle,
              ref5inViewport ? "" : styles.mobileShrinkable
            )}
            onClick={() =>
              ref5?.current?.scrollIntoView({
                behavior: "smooth",
                block: "start",
              })
            }
          ></div>
        </div>

        <div className={cx(styles.pageContainer)}>
          <div ref={ref1} className={cx(styles.experience)}>
            <h1 className="py-2">تحلیل احساس در رسانه‌ها و شبکه‌های اجتماعی</h1>
            <p>
              بررسی و رصد شبکه‌های اجتماعی و تحلیل احساس کاربران نسبت به
              دیجی‌کالا یکی از ابزارهای دیجی‌کالا برای سنجش کیفیت تجربه کاربران
              است. واحد ارتباطات سازمانی دیجی‌کالا روزانه پلتفرم‌های شبکه‌
              اجتماعی را رصد می‌کند تا صدای کاربرانی که درباره‌ی دیجی‌کالا صحبت
              می‌کنند را بشنود. در این راستا از ابزارهای مبتنی بر هوش مصنوعی
              استفاده می‌شود تا مطالب، بازخوردها و واکنش‌های کاربران شبکه
              اجتماعی نسبت به دیجی‌کالا گردآوری و تحلیل شود.
            </p>
            <p>
              کارشناسان تیم ارتباطات سازمانی پس از شنیدن صدای کاربران و مشتریان
              در شبکه‌های اجتماعی با آن‌ها وارد تعامل می‌شوند. برخی از مطالب
              کاربران، به‌صورت مستقیم مرتبط با تجربه مشتریان دیجی‌کالا هستند. در
              چنین مواردی اگر نیاز به پیگیری باشد، کارشناسان تیم ارتباطات
              سازمانی چالش کاربر را به اطلاع سایر واحدها مثل تجربه مشتریان یا
              مرکز تماس می‌رسانند تا مشکل کاربر برطرف شود. علاوه‌بر پیگیری
              موردی، از تمام چالش‌های کاربران نیز گزارش‌هایی تحلیلی تهیه می‌شود
              تا مدیران و راهبران دیجی‌کالا نسبت به برایند بازخورد کاربران آگاه
              باشند.
            </p>
            <p>
              یکی از شاخص‌هایی که به کارشناسان تیم ارتباطات سازمانی کمک می‌کند
              تا از سوگیری و احساسات کاربران سوشال مدیا نسبت به دیجی‌کالا آگاه
              باشند، شاخص احساس اجتماعی یا سنتیمنت (social sentiment) است.
            </p>

            <div className={cx(styles.purpleContainer)}>
              <div className="d-flex text-center py-3">
                <h6>
                  شاخص احساس اجتماعی نسبت بازخوردهای مثبت، خنثی یا منفی نسبت به
                  برند را در شبکه‌های اجتماعی بازگو می‌کند.
                </h6>
              </div>
            </div>
          </div>

          <div ref={ref2} className={cx(styles.experience2)}>
            <div className={cx(styles.cxVline)}>
              <Image src={cxVline} alt="Line" />
            </div>
            <div className={cx(styles.cxVlineVl)}></div>

            <div className="d-block w-100">
              <h2>احساس کاربران توییتر نسبت به دیجی‌کالا</h2>
              <p>
                بالا رفتن تعداد بازخوردهای دارای سنتیمنت مثبت کاربران نسبت به
                دیجی‌کالا، بیانگر رضایت کلی کاربران از دیجی‌کالاست و برعکس.
                احساس کاربران توییتر نسبت به دیجی‌کالا در نیمه اول سال ۱۴۰۱ به
                صورت زیر است:
              </p>

              <Image
                src={sentimentChartDesktop}
                alt="Social Sentiment Chart"
                className={cx(styles.fullautoImage, "my-4 d-none d-md-block")}
              />
              <Image
                src={sentimentChartMobile}
                alt="Social Sentiment Chart"
                className={cx(styles.fullautoImage, "my-4 d-block d-md-none")}
              />

              <p>
                مهمترین دلایل نارضایتی کاربران از دیجی‌کالا در این بازه به ترتیب
                مربوط به قیمت کالاها، لجستیک (عملیات) و پشتیبانی بوده است. در
                حالی که تنوع کالایی بالا، تخفیف‌ها و جشنواره‌های فروش، بیشترین
                احساس مثبت کاربران را برای دیجی‌کالا به ارمغان آورده است.
              </p>
            </div>
          </div>

          <div ref={ref3} className={cx(styles.experience2)}>
            <div className={cx(styles.cxVline)}>
              <Image src={cxVline} alt="Line" />
            </div>
            <div className={cx(styles.cxVlineVl)}></div>

            <div className="d-block w-100">
              <h2>
                احساس کاربران اینستاگرام و لینکدین و تلگرام نسبت به دیجی‌کالا
              </h2>
              <p>
                علاوه بر توییتر، دیدگاه‌های کاربران و مشتریان درباره دیجی‌کالا
                در سایر پلتفرم‌های اجتماعی مانند اینستاگرام، لینکدین و تلگرام
                توسط تیم ارتباطات سازمانی رصد و پایش می‌شود. همچنین اکانت
                دیجی‌کالا به پرسش‌ها و پیام‌های کاربران خود در تمام شبکه‌های
                اجتماعی فعال، پاسخ می‌دهد.
              </p>
            </div>
          </div>

          <div ref={ref4} className={cx(styles.experience2)}>
            <div className={cx(styles.cxVline)}>
              <Image src={cxVline} alt="Line" />
            </div>
            <div className={cx(styles.cxVlineVl)}></div>
            <div className="d-block w-100">
              <h2>سایر راه‌های شنیدن صدای شما</h2>
              <div className={cx("row", styles.otherChannelsRow)}>
                <div className={cx("col-12 col-md-4", styles.otherChannelsCol)}>
                  <Link href="/customer-experience/customer-service/">
                    <div className={cx(styles.otherChannelsInnerContainer)}>
                      <Image src={cx1} alt="Call Center" className="my-4" />
                      <div
                        className={cx(styles.otherChannelsInnerBottomContainer)}
                      >
                        <div className={cx(styles.otherChannelsInnerBottom)}>
                          <h6>تماس مشتریان</h6>
                          <Image
                            src={cxArrow}
                            alt="left arrow"
                            className={cx(styles.leftArrow)}
                          />
                        </div>
                      </div>
                    </div>
                  </Link>
                </div>
                <div className={cx("col-12 col-md-4", styles.otherChannelsCol)}>
                  <Link href="/customer-experience/metric/">
                    <div className={cx(styles.otherChannelsInnerContainer)}>
                      <Image src={cx3} alt="Social media" className="my-4" />
                      <div
                        className={cx(styles.otherChannelsInnerBottomContainer)}
                      >
                        <div className={cx(styles.otherChannelsInnerBottom)}>
                          <h6>شاخص‌های تجربه مشتریان</h6>
                          <Image
                            src={cxArrow}
                            alt="left arrow"
                            className={cx(styles.leftArrow)}
                          />
                        </div>
                      </div>
                    </div>
                  </Link>
                </div>
                <div className={cx("col-12 col-md-4", styles.otherChannelsCol)}>
                  <Link href="/customer-experience/brand-surveys/">
                    <div className={cx(styles.otherChannelsInnerContainer)}>
                      <Image src={cx2} alt="Social media" className="my-4" />
                      <div
                        className={cx(styles.otherChannelsInnerBottomContainer)}
                      >
                        <div className={cx(styles.otherChannelsInnerBottom)}>
                          <h6>تحقیقات برند</h6>
                          <Image
                            src={cxArrow}
                            alt="left arrow"
                            className={cx(styles.leftArrow)}
                          />
                        </div>
                      </div>
                    </div>
                  </Link>
                </div>
              </div>
            </div>
          </div>

          <div ref={ref5} className={cx(styles.experienceShare)}>
            <div className={cx(styles.share)}>
              <div className="d-block">
                <h6 className={cx(styles.shareTitle)}>به اشتراک بگذارید</h6>
              </div>
              <div className="d-block">
                <span
                  onClick={onShareHandler}
                  className={cx(styles.copyLink, "me-3")}
                >
                  <Image src={linkShare} alt="Link Share" />
                </span>
                <a
                  className="me-3"
                  target="_blank"
                  rel="noreferrer"
                  href={`mailto:?subject=${pageDetails.pageTitle}
                                &${pageDetails.pagePath}
                                &body=سلام %0A این صفحه از سایت درباره دیجی‌کالا رو ببین.%0A سپاس
                                `}
                >
                  <Image src={emailShare} alt="Email Share" />
                </a>
                <a
                  className="me-3"
                  rel="noreferrer"
                  target="_blank"
                  href={`https://t.me/share/url?url=${pageDetails.pagePath}} 
                    &text=${encodeURIComponent(pageDetails.pageTitle)}`}
                >
                  <Image src={telegramShare} alt="Telegram Share" />
                </a>
                <a
                  target="_blank"
                  rel="noreferrer"
                  href={`whatsapp://send?text=${encodeURIComponent(
                    pageDetails.pagePath
                  )}`}
                  data-action="share/whatsapp/share"
                >
                  <Image src={whatsappShare} alt="Whatsapp Share" />
                </a>
              </div>
            </div>

            <div className={cx(styles.comment)}>
              <div className="d-block">
                <h6 className={cx(styles.shareTitle)}>
                  آیا این مطلب برایتان مفید بود؟
                </h6>
              </div>
              <div className="d-block">
                <span className="me-3">
                  <Image
                    src={dislike}
                    alt="Dislike"
                    style={{ cursor: "pointer" }}
                  />
                </span>
                <span>
                  <Image src={like} alt="Like" style={{ cursor: "pointer" }} />
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Index;
